import { Box, Text } from '@chakra-ui/react'

export const Copyright = () => {
  const currentYear = new Date().getFullYear()

  return (
    <Box textAlign="center" my={2}>
      <Text color="white" fontSize="2xs">
        COPYRIGHT ©2018-{currentYear} Amazia, Inc. All Rights Reserved.
      </Text>
    </Box>
  )
}
